import { useEffect, useState } from "react";
import api from "../services/api";
import "../styles/pos.css";

const Branches = () => {
  const [branches, setBranches] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const [form, setForm] = useState({
    branch_name: "",
    branch_code: "",
    address: "",
    state: "",
    mobile: "",
    gstin: ""
  });

  const loadBranches = async () => {
    const res = await api.get("/branches");
    setBranches(res.data || []);
  };

  useEffect(() => {
    loadBranches();
  }, []);

  const addBranch = async () => {
  if (!form.branch_name || !form.branch_code) {
    alert("Branch name & code required");
    return;
  }

  const payload = {
    ...form,
    branch_name: form.branch_name.trim().toUpperCase(),
    branch_code: form.branch_code.trim().toUpperCase(),
    gstin: form.gstin?.trim().toUpperCase()
  };

  try {
    await api.post("/branches", payload);
    setForm({
      branch_name: "",
      branch_code: "",
      address: "",
      state: "",
      mobile: "",
      gstin: ""
    });
    setShowForm(false);
    loadBranches();
  } catch (err) {
    alert(err.response?.data?.error || "Failed to add branch");
  }
};


  return (
    <div className="page-container">
      {/* ===== HEADER ===== */}
      <div className="page-header">
        <h2>Branches</h2>
        <button
          className="primary-btn"
          onClick={() => setShowForm(!showForm)}
        >
          ➕ Add Branch
        </button>
      </div>

      {/* ===== ADD FORM ===== */}
      {showForm && (
        <div className="card">
          <h4>Add New Branch</h4>

          <div className="form-row">
            <input
  placeholder="Branch Name"
  value={form.branch_name}
  onChange={e =>
    setForm({
      ...form,
      branch_name: e.target.value.toUpperCase()
    })
  }
/>
            <input
              placeholder="Branch Code"
              value={form.branch_code}
              onChange={e =>
                setForm({ ...form, branch_code: e.target.value })
              }
            />
          </div>

<div className="form-row">
          <input
            placeholder="Address"
            value={form.address}
            onChange={e =>
              setForm({ ...form, address: e.target.value })
            }
          />
          <input
  placeholder="GSTIN"
  value={form.gstin}
  onChange={e =>
    setForm({
      ...form,
      gstin: e.target.value.toUpperCase()
    })
  }
/>
          </div>

          <div className="form-row">
            <input
              placeholder="State"
              value={form.state}
              onChange={e =>
                setForm({ ...form, state: e.target.value })
              }
            />
            <input
              placeholder="Mobile"
              value={form.mobile}
              onChange={e =>
                setForm({ ...form, mobile: e.target.value })
              }
            />
          </div>

          <button className="primary-btn" onClick={addBranch}>
              Save Branch
          </button>
        </div>
      )}

      {/* ===== BRANCH LIST ===== */}
      <div className="invoice-table print-container">
      <table>
        <thead>
          <tr>
            <th>Branch Name</th>
            <th>Code</th>
            <th>State</th>
            <th>Mobile</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {branches.map(b => (
            <tr key={b.branch_id}>
              <td><b>{b.branch_name.toUpperCase()}</b></td>
              <td>{b.branch_code}</td>
              <td>{b.state || "-"}</td>
              <td>{b.mobile || "-"}</td>
              <td>
                <span className={`badge ${b.is_active ? "active" : "inactive"}`}>
                  {b.is_active ? "Active" : "Inactive"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Branches;
